import React from 'react';
import PropTypes from 'prop-types';

import { Progress } from 'semantic-ui-react';

import './ShopifyConnectionProgressBar.css';

const ShopifyConnectionProgressBar = ({ shopifyStoreInfo }) => {
  const productsCount = shopifyStoreInfo.products_count;
  const syncProductsDone = shopifyStoreInfo.sync_products_done;
  const percent = ((syncProductsDone / productsCount) * 100).toFixed(0);

  return (
    <div className="shopify-connection-progress-bar__component">
      <div className="percent-value">{percent}%</div>
      <Progress percent={percent} size="small" />
      <div className="products-synchronized">
        <div className="text">
          Products synchronized: {syncProductsDone}/{productsCount}
        </div>
        {productsCount ===  syncProductsDone &&
          <div className="icon" />
        }
      </div>
    </div>
  );
};

ShopifyConnectionProgressBar.propTypes = {
  shopifyStoreInfo: PropTypes.object.isRequired,
};

export default ShopifyConnectionProgressBar;
